import { Button } from "@mui/material";

interface SudoButtonProps {
  /** Ссылка одноразового входа: User.sudoUrl / Organization.sudoUrl / Platform.sudoUrl */
  href: string;
  label: string;
}

/**
 * Кнопка судо-входа: открывает welcome-ссылку в новой вкладке, чтобы
 * сессия админа в текущей вкладке не терялась. rel="noopener noreferrer"
 * обязателен при target="_blank": noopener не даёт открытой странице
 * получить доступ к window.opener, noreferrer вдобавок не передаёт ей
 * заголовок Referer с этим самым welcome-токеном.
 */
export function SudoButton({ href, label }: SudoButtonProps) {
  return (
    <Button
      variant="outlined"
      size="small"
      href={href}
      target="_blank"
      rel="noreferrer noopener"
    >
      {label}
    </Button>
  );
}
